import {createContext, useContext, useState, useEffect} from "react";
import {
  UserProfileModel,
  UserProfileJSON,
  UserProfileFactory,
  UserUIPreferenceModel,
  UserUIPreferenceFactory} from "../models/modelsUserConfiguration";
import Config from "../config";
import { useAuth } from "./useAuth";
import {retrieveUserProfile,
        retrieveUserPreference} from "../services/userConfigurationApi";

const UserContext = createContext<{
  userPreference: UserUIPreferenceModel | null,
  userProfile: UserProfileModel | null,
  isLoading: boolean
}>({
  userPreference: null,
  userProfile: null,
  isLoading: false
});

type UserProviderProps = {
  children: React.ReactNode;
};

export const UserProvider = ({children}: UserProviderProps) => {

  const {accessToken} = useAuth();

  const [userPreference, setUserPreference] = useState<UserUIPreferenceModel | null>(null);
  const [userProfile, setUserProfile] = useState<UserProfileModel | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const retrieveUserContext = async(accessToken: string) => {

    setIsLoading(true)

    try {
      const [thisUserProfile, thisUserPreference] = await Promise.all([
        retrieveUserProfile(accessToken),
        retrieveUserPreference(accessToken)
      ])

      setUserProfile(thisUserProfile)
      setUserPreference(thisUserPreference)
      setIsLoading(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
    } finally {
      setIsLoading(false)
    }
  }


  useEffect(() => {
    if(accessToken) {
      retrieveUserContext(accessToken)
    }

  }, [accessToken])

  const value = {
    userPreference: userPreference,
    userProfile: userProfile,
    isLoading: isLoading
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;

}

export const useUser = () => {
  return useContext(UserContext)
}
